"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMotivoNaoEfetivo = void 0;
var EMotivoNaoEfetivo;
(function (EMotivoNaoEfetivo) {
    EMotivoNaoEfetivo["Nenhum"] = "";
    EMotivoNaoEfetivo["Valor Alto"] = "01";
    EMotivoNaoEfetivo["S\u00F3 Quer Valor Por Telefone"] = "03";
    EMotivoNaoEfetivo["Escola N\u00E3o Atende Faixa Et\u00E1ria"] = "04";
    EMotivoNaoEfetivo["Aluno Especial Quer Bolsa"] = "05";
    EMotivoNaoEfetivo["Localiza\u00E7\u00E3o"] = "08";
    EMotivoNaoEfetivo["Vai Deixar Para o Pr\u00F3ximo Ano"] = "09";
    EMotivoNaoEfetivo["Est\u00E1 Fazendo Cota\u00E7\u00F5es"] = "10";
    EMotivoNaoEfetivo["Matriculou na Rede P\u00FAblica"] = "11";
    EMotivoNaoEfetivo["Matriculou em Outra Escola Particular"] = "12";
    EMotivoNaoEfetivo["Precisa de Uma Escola Que N\u00E3o Pare nas F\u00E9rias"] = "13";
    EMotivoNaoEfetivo["Precisa de Bolsa"] = "14";
    EMotivoNaoEfetivo["Problemas de Sa\u00FAde"] = "15";
    EMotivoNaoEfetivo["N\u00E3o Declarado"] = "16";
    EMotivoNaoEfetivo["Mudou de Cidade"] = "17";
    EMotivoNaoEfetivo["Estrutura N\u00E3o Agradou"] = "18";
    EMotivoNaoEfetivo["Material Did\u00E1tico"] = "19";
    EMotivoNaoEfetivo["Pandemia"] = "20";
})(EMotivoNaoEfetivo = exports.EMotivoNaoEfetivo || (exports.EMotivoNaoEfetivo = {}));
